module.exports = __webpack_public_path__ + "img/knc.413200d1.svg";